import React from 'react'
import {Box, Typography, Tooltip} from '@material-ui/core'
import PhoneIcon from '@material-ui/icons/Phone'

// Import logo from local assets
// Adjust the path based on your folder structure

interface ContactCardProps {
  name?: string
  phone?: string
  extension?: string
  availability?: string
}

interface ContactCardProps {
  text: string
}

const ContactCard: React.FC<ContactCardProps> = ({text}) => {
  const [main, availability] = text.split('&').map((str) => str.trim())
  const phoneRegex = /(\d{3}[-.\s]?\d{3}[-.\s]?\d{4}(?:,{1,}[\d#]+)?)/

  const phoneMatch = main.match(phoneRegex)

  let phoneNumber = ''
  let telLink = ''

  if (phoneMatch) {
    // Remove non-digit or comma characters for tel: link
    phoneNumber = phoneMatch[1]
    const cleanNumber = phoneNumber.replace(/[^0-9,]/g, '')

    telLink = `tel:${cleanNumber}`
  }

  const mainWithoutPhone = phoneMatch
    ? main
        .replace(phoneMatch[1], '')
        .replace(/\s*-+\s*$/, '')
        .trim()
    : main
  return (
    <Box
      display="flex"
      alignItems="center"
      padding={1}
      borderRadius={4}
      maxWidth={350}
    >
      {phoneNumber ? (
        <Tooltip title={`Call ${phoneNumber}`}>
          <a href={telLink} style={{marginRight: 8}}>
            <PhoneIcon style={{fontSize: 25}} />
          </a>
        </Tooltip>
      ) : (
        <PhoneIcon style={{fontSize: 32}} />
      )}

      <Box>
        <Typography variant="body1">{mainWithoutPhone}</Typography>
        <Typography variant="body2" style={{color: 'gray', fontSize: '10px'}}>
          {availability}
        </Typography>
      </Box>
    </Box>
  )
}

export default ContactCard
